module.exports = __webpack_public_path__ + "img/qr1.b99dc8c2.png";